import ForecastCard from "../cards/forecast.card";
import LineProjectionCard from "../cards/futureworth.line.graph";
import ForecastYearsCard from "../cards/forecast.years.card";
import {ArrowUpRightIcon} from "@phosphor-icons/react";
import {useProfile} from "context/profile.context";
import {useData} from "context/data.context";
import {formatCurrencyCompact} from "utilities/global.functions";

const ForecastPanel = () => {
  const {targetAge, targetNetworth, birthYear} = useProfile();
  const {networthProjected} = useData();

  // null = the target isn't reached inside the 50 year scan; exactly 0 = already there.
  // All branching reads the raw number — `yearsToTarget` is a display string only.
  const {yearsToTargetNetworth} = networthProjected;
  const reached = yearsToTargetNetworth !== null;
  const alreadyReached = yearsToTargetNetworth === 0;
  const yearsToTarget = reached ? yearsToTargetNetworth.toFixed(1) : null;
  // Floored, not rounded: crossing at t = 19.7 happens *during* the 19th year from now,
  // not the 20th. Only used as a fallback when there's no birth year to compare ages with.
  const targetYear = reached ? new Date().getFullYear() + Math.floor(yearsToTargetNetworth) : null;

  // How the crossing lands against the age they planned to hit it. Negative = ahead of plan.
  // null without a birth year, since there's no age to measure from.
  const ageAtTarget = reached && birthYear ? new Date().getFullYear() - birthYear + yearsToTargetNetworth : null;
  const ageGap = ageAtTarget !== null ? ageAtTarget - targetAge : null;
  const onTarget = ageGap !== null && Math.abs(ageGap) < 0.05; // rounds to 0.0 years
  const early = ageGap !== null && ageGap < 0;

  return (
    <div className="Forecast dark">
      <div className="Header" />
      <div className="flex  col large-gap">
        <div className="padding">
          <p className="xlarge ">Futureworth</p>
        </div>
        <div className="card flex  spacing--large col xxxlarge-gap">
          <ForecastCard />
          <ForecastYearsCard />
          <LineProjectionCard />
        </div>

        <div className="grid col-2 large-gap ">
          <div className="card r4-3 flex col space pointer">
            <div className="flex row space">
              <div className="flex col small-gap">
                <p className="large">Target networth</p>
                <div className="flex row">
                  {/* <ArrowUpRightIcon size={44} /> */}
                  <p className="medium o70">
                    Your goal of {formatCurrencyCompact(targetNetworth)}
                    {alreadyReached ? " has been reached" : " could be reached in"}
                  </p>
                </div>
              </div>
            </div>

            <div className="flex col medium-gap">
              <div className="flex row baseline medium-gap">
                {alreadyReached ? (
                  <p className="number xxxlarge l4">—</p>
                ) : (
                  <>
                    <p className="number xxxlarge l4">{!reached ? "50+" : yearsToTarget}</p>
                    <p className="large">years</p>
                  </>
                )}
              </div>
              {/* {!alreadyReached && (
                <div className="flex row center medium-gap">
                  {!reached ? (
                    <div className="flag liability flex row center small-gap">Not reached within 50 years</div>
                  ) : ageGap === null ? (
                    // No birth year on file, so there's no age to compare against
                    <div className="flag flex row center small-gap">{targetYear}</div>
                  ) : onTarget ? (
                    <>
                      <div className="flag asset flex row center small-gap">On track</div>
                      <p className="small">for your target age of {targetAge}</p>
                    </>
                  ) : (
                    <>
                      <div className={`flag ${early ? "asset" : "liability"} flex row center small-gap`}>{Math.abs(ageGap).toFixed(1)} years</div>
                      <p className="medium">
                        {early ? "earlier than" : "after"} your target age of {targetAge}
                      </p>
                    </>
                  )}
                </div>
              )} */}
            </div>
          </div>

          <div className="card r4-3 flex col space pointer">
            <div className="flex row space">
              <div className="flex col small-gap">
                <p className="large">Target age</p>
                <div className="flex row">
                  {/* <ArrowUpRightIcon size={44} /> */}
                  <p className="medium o70">You could reach your target in</p>
                </div>
              </div>
            </div>

            <div className="flex col medium-gap">
              <div className="flex row baseline medium-gap">
                <p className="number xxxlarge l4">11</p>
                <p className="large"> years</p>
              </div>
              {/* <div className="flex row center medium-gap">
                <div className="flag liability flex row center small-gap">+ 2 years</div>
                <p className="small">more than your target age of {targetAge}</p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForecastPanel;
